<template>
  <iRow
    width="fill"
    height="hug"
    gap="none"
    vertical-align="middle"
    :style-overrides="{backgroundColor: styles.barBackground, ...TRACK}"
    :border-top="styles.barBorder.top"
    :border-right="styles.barBorder.right"
    :border-bottom="styles.barBorder.bottom"
    :border-left="styles.barBorder.left"
    role="radiogroup"
  >
    <iRow
      v-for="segment in segments"
      :key="segment.key"
      width="fill"
      height="hug"
      align="center"
      vertical-align="middle"
      clickable
      role="radio"
      :aria-checked="segment.selected ? 'true' : 'false'"
      :data-test="`plan-segment-${segment.key}`"
      :style-overrides="{backgroundColor: segment.selected ? styles.selectedBackground : styles.unselectedBackground, ...SEGMENT}"
      :border-top="borderFor(segment).top"
      :border-right="borderFor(segment).right"
      :border-bottom="borderFor(segment).bottom"
      :border-left="borderFor(segment).left"
      @click="$emit('select', segment.key)"
    >
      <iText :style-overrides="styles.text">
        {{ segment.label }}
      </iText>
      <iText
        v-if="segment.badge"
        :style-overrides="styles.text"
        data-test="plan-segment-badge"
      >
        {{ segment.badge }}
      </iText>
    </iRow>
  </iRow>
</template>

<script>
// A pill switch: a rounded, padded track with rounded segments inside.
const TRACK = { borderRadius: "large", paddingTop: "extraSmall", paddingBottom: "extraSmall",
  paddingLeft: "extraSmall", paddingRight: "extraSmall" };
const SEGMENT = { borderRadius: "large", paddingTop: "small", paddingBottom: "small",
  paddingLeft: "standard", paddingRight: "standard" };

// Presentational segmented control; the owning element supplies segments + resolved styles.
export default {
  name: "PlanSegmentedControl",
  props: {
    segments: {
      type: Array,
      required: true,
    },
    styles: {
      type: Object,
      required: true,
    },
  },
  emits: ["select"],
  data() {
    return { TRACK, SEGMENT };
  },
  methods: {
    borderFor(segment) {
      return segment.selected ? this.styles.selectedBorder : this.styles.unselectedBorder;
    },
  },
};
</script>
